import { FileUploadDesignTokens } from '@primeuix/themes/types/fileupload';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/fileupload/index.ts
const fu = tDeep(componentCommon.fileupload);

export const FileUploadTelekomDT: FileUploadDesignTokens = {
  root: {
    background: fu.background,
    borderColor: fu.border.color,
    color: fu.color,
    borderRadius: fu.border.radius,
  },
  header: {
    background: fu.header.background,
    color: fu.header.color,
    padding: fu.header.padding,
    borderColor: fu.header.border.color,
    borderWidth: fu.header.border.width,
    borderRadius: fu.header.border.radius,
    gap: fu.header.gap,
  },
  content: {
    highlightBorderColor: fu.content.highlight.border.color,
    padding: `${fu.content.padding.top} ${fu.content.padding.right} ${fu.content.padding.bottom} ${fu.content.padding.left}`,
    gap: fu.content.gap,
  },
  file: {
    padding: fu.file.padding,
    gap: fu.file.gap,
    borderColor: fu.file.border.color,
    info: { gap: fu.file.info.gap },
  },
  fileList: {
    gap: fu.file.list.gap,
  },
  progressbar: {
    height: fu.progressbar.height,
  },
  basic: {
    gap: fu.basic.gap,
  },
};
